__webpack_require__.p = "https://prana-club.com/app-static/app-production-f7275dfd01d7-1/_next/";